import { Key, useCallback, useContext, useMemo } from "react"
import {
  Button,
  IconProps,
  LogIn01,
  Plus,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import {
  resetDepositState,
  resetOnboardingFlow,
  setOpenModal,
  useDappDispatch,
} from "#/redux-state"
import { IS_MEZO_MAINNET, routes } from "#/shared/constants"
import { FlowContext } from "#/shared/context"

type DepositEmptyStateButtonProps = {
  onClick: (key: Key) => void
}

export default function DepositEmptyStateButton({
  onClick,
}: DepositEmptyStateButtonProps) {
  const dispatch = useDappDispatch()

  const { flow } = useContext(FlowContext)
  const [, theme] = useStyletron()

  const buttonClickHandler = useCallback(() => {
    if (IS_MEZO_MAINNET) {
      dispatch(resetOnboardingFlow())
      dispatch(setOpenModal("onboarding"))
    } else {
      dispatch(resetDepositState({ flow }))
      onClick("new-deposit")
    }
  }, [dispatch, flow, onClick])

  const iconProps: IconProps = useMemo(
    () => ({ color: theme.colors.white, size: theme.sizing.scale600 }),
    [theme],
  )

  return (
    <Button
      $as={Link}
      href={`${routes.DEPOSIT}?tab=new-deposit`}
      size="medium"
      onClick={buttonClickHandler}
      startEnhancer={
        IS_MEZO_MAINNET ? <LogIn01 {...iconProps} /> : <Plus {...iconProps} />
      }
      overrides={{ BaseButton: { style: () => ({ width: "140px" }) } }}
    >
      {IS_MEZO_MAINNET ? "Sign in" : "Deposit"}
    </Button>
  )
}
